export enum STODocumentStatusEnum {
  QUEUE = 'queue',
  PICKING = 'picking',
  SHIP_UPDATING = 'ship-updating',
  SHIP_UPDATE_FAILED = 'ship-update-failed',
  SHIPPED = 'shipped',
  ARRIVED = 'arrived',
  RECEIVING = 'receiving',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}
